export default {
  name: 'noValue',
  filter: function (value) {
    return value || '-'
  }
}
